// THIS FILE IS AUTO-GENERATED. DO NOT EDIT DIRECTLY

/* eslint no-unused-vars: 0 */ import * as Api from '../apiModels';
import { FetchResponse } from '../fetchResponse';
import { GetAsync, PostAsync } from '@maxpreps/network/src/simpleWrapper';
import { CsString } from '../cs-mappers/CsString';
export const GetArticlesBySectionSportAsync = async (
  sectionId: string,
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.LeanArticle[]>> =>
  GetAsync<Api.LeanArticle[]>(
    `gatewayweb/react/articles-by-section/v1?sectionId=${sectionId}&allSeasonId=${allSeasonId}`,
    token,
    headers
  );
export const GetContestCalculatedAsync = async (
  contestId: string,
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCalculatedGateway>> =>
  GetAsync<Api.ContestCalculatedGateway>(
    `gatewayweb/react/contest-calculated/v1?contestId=${contestId}&teamId=${teamId}&sportSeasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetScheduleCalculatedAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCalculatedGateway[]>> =>
  GetAsync<Api.ContestCalculatedGateway[]>(
    `gatewayweb/react/schedule-calculated/v1?teamId=${teamId}&sportSeasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetScheduleSeasonsAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AvailableSeason[]>> =>
  GetAsync<Api.AvailableSeason[]>(
    `gatewayweb/react/schedule-seasons/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetScheduleSummaryAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ScheduleSummary>> =>
  GetAsync<Api.ScheduleSummary>(
    `gatewayweb/react/schedule-summary/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetSeasonTournamentBracketsAsync = async (
  stateCode: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.SeasonTournamentBracketList>> =>
  GetAsync<Api.SeasonTournamentBracketList>(
    `gatewayweb/react/season-brackets/v1?stateCode=${stateCode}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetNextContestBoxAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.NextContestBox>> =>
  GetAsync<Api.NextContestBox>(
    `gatewayweb/react/next-contest-box/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetContestIdsGroupedByDateByContextAsync = async (
  context: Api.ContestContextType,
  id: string,
  genderSport: string,
  level: string = 'Varsity',
  excludeTbaDate: Boolean = true,
  nationalTeamCount: number = 25,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestIdsByDate[]>> =>
  GetAsync<Api.ContestIdsByDate[]>(
    `gatewayweb/react/contest-ids-grouped-by-date-by-context/v1?context=${context}&id=${id}&genderSport=${genderSport}&level=${level}&excludeTbaDate=${excludeTbaDate}&nationalTeamCount=${nationalTeamCount}`,
    token,
    headers
  );
export const GetContestIdsGroupedByDateByContext_V2Async = async (
  context: Api.ContestContextType,
  id: string,
  genderSport: string,
  level: string = 'Varsity',
  excludeTbaDate: Boolean = true,
  nationalTeamCount: number = 25,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestIdsByDateList>> =>
  GetAsync<Api.ContestIdsByDateList>(
    `gatewayweb/react/contest-ids-grouped-by-date-by-context/v2?context=${context}&id=${id}&genderSport=${genderSport}&level=${level}&excludeTbaDate=${excludeTbaDate}&nationalTeamCount=${nationalTeamCount}`,
    token,
    headers
  );
export const GetContestIdsGroupedByDateByTeamsBulkAsync = async (
  teamInputs: Api.AllSeasonTeam[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestIdsByDate[]>> =>
  PostAsync<Api.ContestIdsByDate[]>(
    `gatewayweb/react/contest-ids-grouped-by-date-by-all-season-teams/v1`,
    teamInputs,
    token,
    headers
  );
export const GetScoreboardContestsByIdsBasicAsync = async (
  contestIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ScoreboardContestBasic[]>> =>
  PostAsync<Api.ScoreboardContestBasic[]>(
    `gatewayweb/react/scoreboard-contests-by-ids/basic/v1`,
    contestIds,
    token,
    headers
  );
export const GetScoreboardContestsByIdsAsync = async (
  contestIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ScoreboardContest[]>> =>
  PostAsync<Api.ScoreboardContest[]>(
    `gatewayweb/react/scoreboard-contests-by-ids/v1`,
    contestIds,
    token,
    headers
  );
export const GetHomeGroupingsAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.HomeGroupings>> =>
  GetAsync<Api.HomeGroupings>(
    `gatewayweb/react/groupings/home/v1`,
    token,
    headers
  );
export const GetStatesByAllSeasonAsync = async (
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GroupingStateList>> =>
  GetAsync<Api.GroupingStateList>(
    `gatewayweb/react/groupings/states/v1?allSeasonId=${allSeasonId}`,
    token,
    headers
  );
export const GetStateSportGroupingsAsync = async (
  stateCode: string,
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.StateSportGroupings>> =>
  GetAsync<Api.StateSportGroupings>(
    `gatewayweb/react/groupings/state-sports/v1?stateCode=${stateCode}&allSeasonId=${allSeasonId}`,
    token,
    headers
  );
export const GetStateGroupingsAsync = async (
  stateCode: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.StateGroupings>> =>
  GetAsync<Api.StateGroupings>(
    `gatewayweb/react/groupings/state/v1?stateCode=${stateCode}`,
    token,
    headers
  );
export const GetSectionGroupingsAsync = async (
  stateCode: string,
  allSeasonId: string,
  sectionId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.SectionGroupings>> =>
  GetAsync<Api.SectionGroupings>(
    `gatewayweb/react/groupings/sections/v1?stateCode=${stateCode}&allSeasonId=${allSeasonId}&sectionId=${sectionId}`,
    token,
    headers
  );
export const GetHighSchoolJsonLdAsync = async (
  schoolId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/high-school/v1?schoolId=${schoolId}`,
    token,
    headers
  );
export const GetSchoolBreadcrumbsJsonLdAsync = async (
  schoolId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/school-breadcrumbs/v1?schoolId=${schoolId}`,
    token,
    headers
  );
export const GetNationalSportBreadcrumbsJsonLdAsync = async (
  genderSport: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/national-sport-breadcrumbs/v1?genderSport=${genderSport}`,
    token,
    headers
  );
export const GetStateSportBreadcrumbsJsonLdAsync = async (
  genderSport: string,
  stateCode: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/state-sport-breadcrumbs/v1?genderSport=${genderSport}&stateCode=${stateCode}`,
    token,
    headers
  );
export const GetTeamBreadcrumbsJsonLdAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/team-breadcrumbs/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetTeamJsonLdAsync = async (
  teamId: string,
  sportSeasonId: string,
  includeRoster: Boolean = false,
  includeSchedule: Boolean = false,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/team/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}&includeRoster=${includeRoster}&includeSchedule=${includeSchedule}`,
    token,
    headers
  );
export const GetSectionSportBreadcrumbsJsonLdAsync = async (
  genderSport: string,
  sectionId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(
    `gatewayweb/react/jsonld/section-sport-breadcrumbs/v1?genderSport=${genderSport}&sectionId=${sectionId}`,
    token,
    headers
  );
export const GetHomeJsonLdAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  GetAsync<string>(`gatewayweb/react/jsonld/home/v1`, token, headers);
export const GetStateSportContextMenu = async (
  stateCode: string,
  allSeasonId: string,
  seasonName: string = '',
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ConcordiaNav>> =>
  GetAsync<Api.ConcordiaNav>(
    `gatewayweb/react/menus/states/${stateCode}/state-sport-context-menu/v1?allSeasonId=${allSeasonId}&seasonName=${seasonName}`,
    token,
    headers
  );
export const GetStateContextMenu = async (
  stateCode: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ConcordiaNav>> =>
  GetAsync<Api.ConcordiaNav>(
    `gatewayweb/react/menus/states/${stateCode}/state-context-menu/v1`,
    token,
    headers
  );
export const GetSectionSportContextMenu = async (
  sectionId: string,
  allSeasonId: string,
  seasonName: string = '',
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ConcordiaNav>> =>
  GetAsync<Api.ConcordiaNav>(
    `gatewayweb/react/menus/sections/${sectionId}/section-sport-context-menu/v1?allSeasonId=${allSeasonId}&seasonName=${seasonName}`,
    token,
    headers
  );
export const GetHomeQuickLinksAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ReactBasicLink[]>> =>
  GetAsync<Api.ReactBasicLink[]>(
    `gatewayweb/react/menus/home-quick-links/v1`,
    token,
    headers
  );
export const GetNationalPhotoGalleriesAsync = async (
  allSeasonId: string,
  pageSize: number = 20,
  page: number = 1,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ReactSportPhotogalleryList>> =>
  GetAsync<Api.ReactSportPhotogalleryList>(
    `gatewayweb/react/national-sport-photo-galleries/v1?allSeasonId=${allSeasonId}&pageSize=${pageSize}&page=${page}`,
    token,
    headers
  );
export const GetSectionGalleriesAsync = async (
  allSeasonId: string,
  sectionId: string,
  pageSize: number = 20,
  page: number = 1,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ReactSportPhotogalleryList>> =>
  GetAsync<Api.ReactSportPhotogalleryList>(
    `gatewayweb/react/section-sport-photo-galleries/v1?allSeasonId=${allSeasonId}&sectionId=${sectionId}&pageSize=${pageSize}&page=${page}`,
    token,
    headers
  );
export const GetStateSportPhotoGalleriesAsync = async (
  allSeasonId: string,
  stateCode: string,
  pageSize: number = 10,
  page: number = 1,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ReactSportPhotogalleryList>> =>
  GetAsync<Api.ReactSportPhotogalleryList>(
    `gatewayweb/react/state-sport-photo-galleries/v1?allSeasonId=${allSeasonId}&stateCode=${stateCode}&pageSize=${pageSize}&page=${page}`,
    token,
    headers
  );
export const GetStatePhotoGalleriesAsync = async (
  stateCode: string,
  pageSize: number,
  page: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ReactSportPhotogalleryList>> =>
  GetAsync<Api.ReactSportPhotogalleryList>(
    `gatewayweb/react/state-photo-galleries/v1?stateCode=${stateCode}&pageSize=${pageSize}&page=${page}`,
    token,
    headers
  );
export const GetTeamRankingsAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamRankingContextList>> =>
  GetAsync<Api.TeamRankingContextList>(
    `gatewayweb/react/team-rankings-context/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetTopTeamRankingsNationalAsync = async (
  allSeasonId: string,
  count: number | null,
  teamSize: number | null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TopTeamRankingList>> =>
  GetAsync<Api.TopTeamRankingList>(
    `gatewayweb/react/team-rankings-top-national/v1?allSeasonId=${allSeasonId}&count=${count}&teamSize=${teamSize}`,
    token,
    headers
  );
export const GetTopTeamRankingsStateAsync = async (
  allSeasonId: string,
  stateCode: string,
  count: number | null,
  teamSize: number | null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TopTeamRankingList>> =>
  GetAsync<Api.TopTeamRankingList>(
    `gatewayweb/react/team-rankings-top-state/v1?allSeasonId=${allSeasonId}&stateCode=${stateCode}&count=${count}&teamSize=${teamSize}`,
    token,
    headers
  );
export const GetTopTeamRankingsSectionAsync = async (
  allSeasonId: string,
  sectionId: string,
  count: number | null,
  teamSize: number | null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TopTeamRankingList>> =>
  GetAsync<Api.TopTeamRankingList>(
    `gatewayweb/react/team-rankings-top-section/v1?allSeasonId=${allSeasonId}&sectionId=${sectionId}&count=${count}&teamSize=${teamSize}`,
    token,
    headers
  );
export const GetTeamStandingsAsync = async (
  teamId: string,
  sportSeasonId: string,
  maxCount: number = 3,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamStandings>> =>
  GetAsync<Api.TeamStandings>(
    `gatewayweb/react/team-standings/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}&maxcount=${maxCount}`,
    token,
    headers
  );
export const GetTeamPreviousSeasonsAsync = async (
  teamId: string,
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PreviousSeasonList>> =>
  GetAsync<Api.PreviousSeasonList>(
    `gatewayweb/react/team-previous-seasons/v1?teamid=${teamId}&allSeasonId=${allSeasonId}`,
    token,
    headers
  );
export const GetTeamContextAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamContext>> =>
  GetAsync<Api.TeamContext>(
    `/gatewayweb/react/team-context/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetTeamWallItemsAsync = async (
  teamId: string,
  sportSeasonId: string,
  startIndex: number = 0,
  endIndex: number = 25,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.WallItem[]>> =>
  GetAsync<Api.WallItem[]>(
    `gatewayweb/react/team-wall-items/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}&startIndex=${startIndex}&endIndex=${endIndex}`,
    token,
    headers
  );
export const GetSportsByStateAsync = async (
  stateCode: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.SportList>> =>
  GetAsync<Api.SportList>(
    `gatewayweb/react/sports-by-state/v1?stateCode=${stateCode}`,
    token,
    headers
  );
export const GetGenderSportsGroupedAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GenderSportsGrouped[]>> =>
  GetAsync<Api.GenderSportsGrouped[]>(
    `gatewayweb/react/gender-sports-grouped/v1`,
    token,
    headers
  );
export const GetUserFlyoutMenuAsync = async (
  userId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.UserFlyoutMenu>> =>
  GetAsync<Api.UserFlyoutMenu>(
    `gatewayweb/react/flyout-menu/v1?userid=${userId}`,
    token,
    headers
  );
export const GetUserPageDataAsync = async (
  userId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.UserPageData>> =>
  GetAsync<Api.UserPageData>(
    `gatewayweb/react/user-page-data/v1?userid=${userId}`,
    token,
    headers
  );
export const GetLeadersLinksByGenderSportAndStatAsync = async (
  stateCode: string = '',
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  GetAsync<any>(
    `gatewayweb/react/leaders-links-by-gender-sport-and-stat/v1?state=${stateCode}`,
    token,
    headers
  );
export const GetLeadersLinksByGenderAndSportAsync = async (
  stateCode: string = '',
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Record<string, Api.LeadersLink[]>>> =>
  GetAsync<Record<string, Api.LeadersLink[]>>(
    `gatewayweb/react/leaders-links-by-gender-and-sport/v1?state=${stateCode}`,
    token,
    headers
  );
export const ContestsByTeamAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteWithHudl>> =>
  GetAsync<Api.ContestCompleteWithHudl>(
    `gatewayweb/site/contests-by-team/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const CompleteQwixcoreByQwixcoreIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreCompleteSp>> =>
  GetAsync<Api.QwixcoreCompleteSp>(
    `gatewayweb/site/complete-qwixcore-by-qwixcore-id/v1?qwixcoreGameId=${qwixcoreGameId}`,
    token,
    headers
  );
export const CompleteQwixcoreByContestIdAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreCompleteSp>> =>
  GetAsync<Api.QwixcoreCompleteSp>(
    `gatewayweb/site/complete-qwixcore-by-contest-id/v1?contestId=${contestId}`,
    token,
    headers
  );
export const GetAllScoreReportedStateRestrictionsAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GatewayStateRestriction[]>> =>
  GetAsync<Api.GatewayStateRestriction[]>(
    `gatewayweb/site/score-reported-state-restrictions/v1`,
    token,
    headers
  );
export const GetAthleteContestsForDisplayAsync = async (
  careerId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AthleteContestsForDisplay>> =>
  GetAsync<Api.AthleteContestsForDisplay>(
    `gatewayweb/site/athlete-contests-for-display/v1?careerId=${careerId}`,
    token,
    headers
  );
export const CreateRankingsAsync = async (
  rankingInputs: Api.RankingInput[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamRanking[]>> =>
  PostAsync<Api.TeamRanking[]>(
    'gatewayweb/site/create-rankings/v1',
    rankingInputs,
    token,
    headers
  );
export const SubmitTeamVolunteerRequestAsync = async (
  teamId: string,
  sportSeasonId: string,
  teamVolunteerRequestForm: Api.TeamVolunteerRequestForm,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamVolunteerRequest>> =>
  PostAsync<Api.TeamVolunteerRequest>(
    `gatewayweb/react/team-volunteer-requests/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}`,
    teamVolunteerRequestForm,
    token,
    headers
  );
export const GetUserFavoritesSiteAsync = async (
  userId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.UserFavoritesSite>> =>
  GetAsync<Api.UserFavoritesSite>(
    `gatewayweb/site/user-favorites/v1?userid=${userId}`,
    token,
    headers
  );
export const GetAnalystAthletesSiteAsync = async (
  analystId: string,
  analystCategoryId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AnalystAthleteSite[]>> =>
  GetAsync<Api.AnalystAthleteSite[]>(
    `gatewayweb/site/analyst-athletes/v1?analystid=${analystId}&analystcategoryid=${analystCategoryId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetAnalystPlayerCategoriesSpAsync = async (
  athleteId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AnalystPlayerCategorySp[]>> =>
  GetAsync<Api.AnalystPlayerCategorySp[]>(
    `gatewayweb/site/analyst-player-categories/v1?athleteid=${athleteId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetAllTimeRostersAsync = async (
  teamId: string,
  allSeasonId: string,
  yearCount: number = 10,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AllTimeRosterList>> =>
  GetAsync<Api.AllTimeRosterList>(
    `gatewayweb/react/rosters-all-time/v1?teamId=${teamId}&allSeasonId=${allSeasonId}&yearCount=${yearCount}`,
    token,
    headers
  );
export const GetRostersSeasonsAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AvailableSeason[]>> =>
  GetAsync<Api.AvailableSeason[]>(
    `gatewayweb/react/rosters-seasons/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetRosterSummaryAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.RosterSummary>> =>
  GetAsync<Api.RosterSummary>(
    `gatewayweb/react/roster-summary/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetAnalystAthletesAsync = async (
  analystId: string,
  analystCategoryId: string,
  sportSeasonId: string,
  activeOnly: Boolean = true,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AnalystAthlete[]>> => {
  var queryString = !activeOnly ? `&activeOnly=false` : CsString.empty;

  return GetAsync<Api.AnalystAthlete[]>(
    `gatewayweb/react/analyst-athletes/v1?analystid=${analystId}&analystcategoryid=${analystCategoryId}&sportseasonid=${sportSeasonId}${queryString}`,
    token,
    headers
  );
};
export const GetAnalystAhtletesByAthleteAsync = async (
  athleteId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AnalystAthlete[]>> =>
  GetAsync<Api.AnalystAthlete[]>(
    `gatewayweb/react/analyst-athletes-by-athlete/v1?athleteid=${athleteId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetAnalystAthletesByAthleteBulkAsync = async (
  baseAthletes: Api.BaseAthlete[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AnalystAthlete[]>> =>
  PostAsync<Api.AnalystAthlete[]>(
    'gatewayweb/react/analyst-athletes-by-athlete-bulk/v1',
    baseAthletes,
    token,
    headers
  );
export const GetTeamSeasonStatsAsync = async (
  teamId: string,
  sportSeasonId: string,
  leagueId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamSeasonStats>> => {
  var queryString = leagueId ? `&leagueId=${leagueId}` : CsString.empty;

  return GetAsync<Api.TeamSeasonStats>(
    `gatewayweb/react/team-season-stats/rollup/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}${queryString}`,
    token,
    headers
  );
};
export const GetTeamPlayerStatsAsync = async (
  teamId: string,
  sportSeasonId: string,
  leagueId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerSeasonStats>> => {
  var queryString = leagueId ? `&leagueId=${leagueId}` : CsString.empty;

  return GetAsync<Api.PlayerSeasonStats>(
    `gatewayweb/react/team-season-player-stats/rollup/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}${queryString}`,
    token,
    headers
  );
};
export const GetTeamContestStatsAsync = async (
  teamId: string,
  sportSeasonId: string,
  leagueId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerSeasonStats>> => {
  var queryString = leagueId ? `&leagueId=${leagueId}` : CsString.empty;

  return GetAsync<Api.PlayerSeasonStats>(
    `gatewayweb/react/team-season-game-stats/rollup/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}${queryString}`,
    token,
    headers
  );
};
export const GetTeamStateAssociationQualificationsInfoAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamStateAssociationQualificationsInfo>> =>
  GetAsync<Api.TeamStateAssociationQualificationsInfo>(
    `/gatewayweb/react/state-association-qualifiers/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetTeamStateNominationsInfoAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamStateNominationsInfo>> =>
  GetAsync<Api.TeamStateNominationsInfo>(
    `/gatewayweb/react/state-nominations/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
export const GetNationalLeadersAsync = async (
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ConcordiaLeader[]>> =>
  GetAsync<Api.ConcordiaLeader[]>(
    `/gatewayweb/react/national-leaders/v1?allSeasonId=${allSeasonId}`,
    token,
    headers
  );
export const GetStateSportLeadersAsync = async (
  allSeasonId: string,
  stateCode: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ConcordiaLeader[]>> =>
  GetAsync<Api.ConcordiaLeader[]>(
    `/gatewayweb/react/state-sport-leaders/v1?allSeasonId=${allSeasonId}&stateCode=${stateCode}`,
    token,
    headers
  );
export const GetSectionLeadersAsync = async (
  allSeasonId: string,
  sectionId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ConcordiaLeader[]>> =>
  GetAsync<Api.ConcordiaLeader[]>(
    `/gatewayweb/react/section-leaders/v1?allSeasonId=${allSeasonId}&sectionId=${sectionId}`,
    token,
    headers
  );
export const GetTeamPlayerLeadersAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerSeasonStatsLeader[]>> =>
  GetAsync<Api.PlayerSeasonStatsLeader[]>(
    `/gatewayweb/react/team-player-leaders/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetTeamPlayerLeadersV2Async = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerSeasonStatLeaderList>> =>
  GetAsync<Api.PlayerSeasonStatLeaderList>(
    `/gatewayweb/react/team-player-leaders/v2?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetStatLandingNationalAsync = async (
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.LandingPage>> =>
  GetAsync<Api.LandingPage>(
    `/gatewayweb/react/stat-landing-national/v1?allSeasonId=${allSeasonId}`,
    token,
    headers
  );
export const GetStatLandingStateAsync = async (
  allSeasonId: string,
  stateCode: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.LandingPage>> =>
  GetAsync<Api.LandingPage>(
    `/gatewayweb/react/stat-landing-state/v1?allSeasonId=${allSeasonId}&stateCode=${stateCode}`,
    token,
    headers
  );
export const GetStatLandingSectionAsync = async (
  allSeasonId: string,
  sectionId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.LandingPage>> =>
  GetAsync<Api.LandingPage>(
    `/gatewayweb/react/stat-landing-section/v1?allSeasonId=${allSeasonId}&sectionId=${sectionId}`,
    token,
    headers
  );
export const GetAthleteStatLeaderboardAsync = async (
  sportSeasonId: string,
  contextId: string = '',
  group: string = '',
  subGroup: string = '',
  statName: string = '',
  positionCategory: string = '',
  classYear: number = 0,
  teamSize: number = 0,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.AthleteStatLeaderboard>> => {
  var queryParamList = new Array<string>();
  queryParamList.push(`sportSeasonId=${sportSeasonId}`);

  if (!CsString.isNullOrWhiteSpace(contextId))
    queryParamList.push(`contextId=${contextId.trim()}`);
  if (!CsString.isNullOrWhiteSpace(contextId))
    queryParamList.push(`group=${group.trim()}`);
  if (!CsString.isNullOrWhiteSpace(contextId))
    queryParamList.push(`subGroup=${subGroup.trim()}`);
  if (!CsString.isNullOrWhiteSpace(contextId))
    queryParamList.push(`statName=${statName.trim()}`);
  if (!CsString.isNullOrWhiteSpace(contextId))
    queryParamList.push(`positionCategory=${positionCategory.trim()}`);
  if (classYear > 0) queryParamList.push(`classYear=${classYear}`);
  if (teamSize > 0) queryParamList.push(`teamSize=${teamSize}`);

  var path = `/gatewayweb/react/athlete-stat-leaderboard/v1?${CsString.join(
    '&',
    queryParamList
  )}`;

  return GetAsync<Api.AthleteStatLeaderboard>(path, token, headers);
};
export const GetTeamLeaderboardLeadersAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamLeaderboardLeader[]>> =>
  GetAsync<Api.TeamLeaderboardLeader[]>(
    `/gatewayweb/react/team-leaderboard-leaders/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetTeamLeaderboardLeadersV2Async = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TeamLeaderboardLeaderList>> =>
  GetAsync<Api.TeamLeaderboardLeaderList>(
    `/gatewayweb/react/team-leaderboard-leaders/v2?teamId=${teamId}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetSharedLeaderboardLinksAsync = async (
  allSeasonId: string,
  contextId: string | null,
  contextType: Api.LeaderboardContextType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.LeaderboardLinks>> => {
  var queryString =
    contextId || contextType !== Api.LeaderboardContextType.National
      ? `&contextId=${contextId}&contextType=${contextType}`
      : CsString.empty;

  return GetAsync<Api.LeaderboardLinks>(
    `/gatewayweb/react/leaderboard-shared-links/v1?allSeasonId=${allSeasonId}&contextId=${contextId}&contextType=${contextType}${queryString}`,
    token,
    headers
  );
};
export const GetLeaderboardGroupingsAsync = async (
  stateCode: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.LeaderboardGroupings>> =>
  GetAsync<Api.LeaderboardGroupings>(
    `/gatewayweb/react/leaderboard-groupings/v1?stateCode=${stateCode}&sportSeasonId=${sportSeasonId}`,
    token,
    headers
  );
export const GetSharedLinksAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.StatsLinks[]>> =>
  GetAsync<Api.StatsLinks[]>(
    `/gatewayweb/react/stat-shared-links/v1?teamid=${teamId}&sportseasonid=${sportSeasonId}`,
    token,
    headers
  );
